import { useCallback, useState } from "react";
import Modal from "../generic/Modal";
import { Form, Input, message } from "antd";
import httpClient from "../../api/httpClient";

const BookDemoModal = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [form] = Form.useForm();

  const onClose = useCallback(() => {
    setShowModal(false);
    form.resetFields();
  }, [form]);

  const onFinish = useCallback(async (values) => {
    try {
      setProcessing(true);
      await httpClient.publicPost("contact-us", values);
      message.success(
        "🎉 Demo booked successfully! Our team will contact you soon.",
      );
      onClose();
    } catch (error) {
      console.log("🚀 ~ BookDemoModal.jsx:21 ~ BookDemoModal ~ error:", error);
      message.error("Something went wrong. Please try again.");
    } finally {
      setProcessing(false);
    }
  }, []);

  return (
    <>
      <div onClick={() => setShowModal(true)}>{children}</div>
      {showModal && (
        <Modal
          onCancel={onClose}
          title="Book a Free Demo"
          open
          onOk={() => form.submit()}
          isProcessing={processing}
        >
          <Form
            form={form}
            layout="vertical"
            name="userInfoForm"
            onFinish={onFinish}
          >
            <Form.Item
              name="first_name"
              label="First Name"
              rules={[
                { required: true, message: "Please enter your first name" },
              ]}
            >
              <Input placeholder="Enter first name" />
            </Form.Item>

            <Form.Item
              name="last_name"
              label="Last Name"
              rules={[
                { required: true, message: "Please enter your last name" },
              ]}
            >
              <Input placeholder="Enter last name" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default BookDemoModal;
